import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/migration/upgrade-to-v10/upgrade-to-v10.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
